import { Injectable } from '@angular/core';
import { NavigationEnd, NavigationExtras, Router } from '@angular/router';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private history: string[] = [];
  constructor(
    private router: Router,
    private location: Location
  ) {}

  public startSaveHistory(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // console.log("heeeeeee")
        // console.log(event.urlAfterRedirects)
        // if (localStorage.getItem("twc-history")) {

        // console.log("heeeeeee---1")
        this.localToArray();
        this.history.push(event.urlAfterRedirects);
        // console.log(this.history)
        localStorage.setItem('twc-history', this.history.join(','));
        // } else {

        //  console.log("heeeeeee---2")
        //   this.history.push(event.urlAfterRedirects)
        //   localStorage.removeItem("twc-history");
        //   localStorage.setItem("twc-history", this.history.join(','))
        // }
      }
    });
  }

  localToArray(): any[] {
    if (localStorage.getItem('twc-history')) {
      let a = localStorage.getItem('twc-history')?.split(',') as string[];
      this.history = localStorage.getItem('twc-history') ? a : [];
    }
    return this.history;
  }

  public getHistory(): any[] {
    return this.localToArray();
  }

  public goBack(): void {
    this.localToArray().pop();
    if (this.history.length > 0) {
      this.location.back();
    } else {
      this.router.navigateByUrl('/');
    }
  }

  public getPreviousUrl(): string {
    if (this.localToArray().length > 0) {
      return this.localToArray()[this.history.length - 2];
    }
    return '';
  }

  public clearHistory() {
    this.history = [];
    localStorage.removeItem('twc-history');
  }

  public getPreviousFilterUrl(path: string): any {
    if (this.localToArray().length > 0) {
      const result = this.localToArray().filter(x => x.includes(path));
      // console.log(result)
      if (result.length > 0) {
        let resultQuery = result[result.length - 1].split('?');

        let retObj: any = {};
        let pair = null;
        if (resultQuery.length > 1) {
          let qArr = resultQuery[1].split('&');

          for (let i = 0; i < qArr.length; i++) {
            pair = qArr[i].split('=');
            retObj[pair[0]] = pair[1];
          }
          if (retObj.q) {
            retObj.q = decodeURIComponent(retObj.q);
          }
        }

        let navigationExtras: NavigationExtras = {
          queryParams: retObj,
        };
        return { path: resultQuery[0], query: navigationExtras };
      }
    }

    return { path: path };
  }

  public backToActivitiesOverviewListOrMonthlyList(branchId: string) {
    // check history to find whether preious page is overview list page or monthly list page
    const history = this.getHistory();
    for (let i = history.length; i >= 0; i--) {
      console.log(history[i]);

      let backPath = history[i];

      var isPreiousPageOverviewLIst = new RegExp('^\/activities\/overview\/.+\/list').test(history[i]);
      var isPreiousPageMonthlyLIst = new RegExp('^\/activities\/monthly\/.+\/list').test(history[i]);

      if (isPreiousPageOverviewLIst) {
        let path = this.getPreviousFilterUrl(backPath);
        this.router.navigate([path.path], path.query);
        break;
      } else if (isPreiousPageMonthlyLIst) {
        let path = this.getPreviousFilterUrl(backPath);
        this.router.navigate([path.path], path.query);
        break;
      }

      // back to overview list page if no preious page history
      if (i == 0) {
        let backPath = '/activities/overview/' + branchId + '/list';
        let path = this.getPreviousFilterUrl(backPath);
        this.router.navigate([path.path], path.query);
      }
    }
  }
}
